import React from "react";
import { defineMessages } from "react-intl";
import { makeStyles } from "tss-react/mui";
import { Button } from "../button/Buttons.js";
import "../button/EditButton.js";
const localized = defineMessages({
  label: {
    id: "DownloadCsvButton_label",
    defaultMessage: "Download CSV"
  }
});
const useStyles = makeStyles()((theme) => ({
  downloadCsvButton: {
    borderRadius: theme.custom.defaultBorderRadius * 2
  }
}));
function DownloadCsvButton(props) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement(Button, { ...props, label: props.label ?? localized.label, className: classes.downloadCsvButton });
}
export {
  DownloadCsvButton
};
//# sourceMappingURL=DownloadCsvButton.js.map
